import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { ContractService } from 'src/app/services/contract.service';
import { LoadingService } from 'src/app/services/loading.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { ServiceService } from 'src/app/services/service.service';
@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  client = null;
  allProperties = null;
  clientProperties = null;

  clientConfiguration = [];
  contracts = [];
  services = [];
  Allservices = [];
  legalInformation = [];

  parameterData = null;
  officeHours = null;
  address = null;

  basicDataHasChanged = false;
  serviceHasChanged = [];
  addressHasChanged = false;
  legalHasChanged = [];
  finishedLoading: boolean = false;
  serviceFilter = null;

  legalSections = [
    { title: 'Teilnahmebedingungen', key: 'participation' },
    { title: 'Datenschutzhinweise', key: 'privacy' },
    { title: 'Impressum', key: 'about' },
    { title: 'Kontakt', key: 'contact' }
  ];

  imageProperties = [
    { showValue: 'Logo', key: 'logo', value: null, hint: 'Format: 180 x 90, Typ: .png', hasChanged: false },
    { showValue: 'Favicon', key: 'favicon.path', value: null, hint: 'Format: 16 x 16, Typ: .ico', hasChanged: false },
    { showValue: 'Appleicon', key: 'appletouchicon.path', value: null, hint: 'Format: 76 x 76, Typ: .png', hasChanged: false }
  ];

  roleOptions = [
    { viewValue: 'Anonymous', value: 'ROLE_ANON', state: true },
    { viewValue: 'Vorkunde', value: 'ROLE_PRE_CUSTOMER', state: true },
    { viewValue: 'Kunde/Mitarbeiter', value: 'ROLE_CUSTOMER', state: true },
    { viewValue: 'Aktionspartner', value: 'ROLE_PARTNER', state: true },
    { viewValue: 'Sachbearbeiter', value: 'ROLE_CASEWORKER', state: true },
    { viewValue: 'Administrator', value: 'ROLE_ADMIN', state: true }
  ];

  stateOptions = [
    { viewValue: 'aktiviert', value: 'ACTIVE', state: false },
    { viewValue: 'deaktiviert', value: 'DISABLED', state: false }
  ];

  moduleOptions = [
    { viewValue: 'Aktionswelt', value: 'event', state: false },
    { viewValue: 'Infothek', value: 'news', state: false },
    { viewValue: 'Karte', value: 'card', state: false }
  ];

  filterForm: UntypedFormGroup;
  dataSource: MatTableDataSource<any>;
  displayedColumns = ['active', 'name', 'path', 'permission', 'value', 'action'];
  page = null;
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }

  constructor(
    private contractService: ContractService,
    private serviceService: ServiceService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private overlayService: OverlayService) {
    this.filterForm = this.fb.group({
      searchTerm: '',
      filterByRoles: [[null]],
      filterByStates: [[null]],
      filterByModules: [[null]],
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.filterForm.markAllAsTouched();
      this.filterForm.patchValue({
        searchTerm: params?.searchTerm,
        filterByRoles: ((params?.filterByRoles != '') ? params?.filterByRoles?.split(',') : null),
        filterByStates: ((params?.filterByStates != '') ? params?.filterByStates?.split(',') : null),
        filterByModules: ((params?.filterByModules != '') ? params?.filterByModules?.split(',') : null),
      })
      this.filterServices();
    })
  }

  loadServiceInformation() {
   this.finishedLoading = false
    combineLatest([
      this.serviceService.searchServices(this.filterForm.getRawValue().searchTerm, this.filterForm.getRawValue().filterByStates, this.filterForm.getRawValue().filterByRoles),
      this.contractService.getContracts()
    ]).subscribe((res: any) => {
      console.log(res)
      this.contracts = res[1]['content'];
      this.services = res[0]['content'].map(service => {
        service.value = this.getContractValue(service.path);
        service.active = this.hasContract(service.path);
        return service;
      });
      this.Allservices = res[0]['content'].map(service => {
        service.value = this.getContractValue(service.path);
        service.active = this.hasContract(service.path);
        return service;
      });
      this.dataSource = new MatTableDataSource(this.Allservices);
     this.finishedLoading = true
    });
  }

  filterServices() {
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: this.filterForm.value?.searchTerm,
          filterByRoles: this.filterForm.value?.filterByRoles?.join(),
          filterByStates: this.filterForm.value?.filterByStates?.join(),
          filterByModules: this.filterForm.value?.filterByModules?.join(),
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.loadServiceInformation();
      })
  }


  resetFitler() {
    this.filterForm.reset();
    this.services = this.Allservices;
    this.dataSource = new MatTableDataSource(this.services);
    setTimeout(() => {
     this.finishedLoading = true
    }, 1000);
  }


  updateContractStatus(service) {
    if (service.active) {
      this.contractService.enableOrUpdateContract(service.publicId, service.value).subscribe({
        next: () => {
          this.overlayService.openSnackBar('Service erfolgreich aktiviert');
          this.loadServiceInformation();
        },
        error: (err) => {
          this.overlayService.openSnackBar(`Fehler beim Aktivieren des Services: ${err}`, 'error');
        }
      });
    } else {
      this.contractService.disableContract(this.getContract(service.publicId).publicId).subscribe({
        next: () => {
          this.overlayService.openSnackBar('Service erfolgreich deaktiviert');
          this.loadServiceInformation();
        },
        error: (err) => {
          this.overlayService.openSnackBar(`Fehler beim Aktivieren des Services: ${err}`, 'error');
        }
      });
    }
  }

  private getContractValue(servicePath) {
    for (let contract of this.contracts) {
      if (contract.path === servicePath) {
        return contract.value;
      }
    }
  }

  private hasContract(servicePath) {
    let result = false;
    for (let contract of this.contracts) {
      if (servicePath == contract.path) {
        result = true;
        break;
      }
    }
    return result;
  }

  private getContract(publicId) {
    let result = undefined;
    for (let contract of this.contracts) {
      if (publicId == contract.servicePublicId) {
        result = contract;
        break;
      }
    }
    return result;
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.filterServices()
    }
  }

  updateContract(service) {
    this.contractService.enableOrUpdateContract(service.publicId, service.value).subscribe(() => {
      this.overlayService.openSnackBar('Service erfolgreich aktualisiert');
    },
      err => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren des Services: ${err}`, 'error');
      });
  }
}

